// extracted by mini-css-extract-plugin
module.exports = {"rect-checkbox":"groupRectCheckbox_rect-checkbox__SsDMW"};